module.exports = __webpack_public_path__ + "media/images/vacancies-bg-03-c4082fe0f4088e634f81777145219a75.png";